import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './customInputBronson.css';


export const customInputComponent = (props) => (
  <CustomInputComponentBlur {...props} />
);

export const confirmationNumberComponent = (props) => (
  <CustomInputComponentBlur
    {...props}
    onBlur={props.onChange}
    maxLength={14}
  />
);

const CustomInputComponentBlur = ({
  field,
  onBlur,
  maxLength,
  ...props
}) => {
  let value;
  
  if (props.maskValue) {
    value = props.maskValue(field.value, props);
  } else if (props.value !== undefined && props.value !== null) {
    value = props.value;
  } else {
    value = field.value;
  }

  return (
    <div className={`c-form-field ccpa_c-form-field ${props.styleNote?"ccpa_c-form-pinNumber-Note":''}${props.helpContent ? " ccpa-error" : ""}${props.disabled ? " is-disabled" : ""}`}>
      <div className="c-form-field__box ccpa_form_input">
        <div className={`c-input form-input-text ${props.className || ""}`}>
          <input
            className="c-input__input"
            id={props.id}
            type="text"
            data-tr-component="Input Field"
            data-tr-function="Text Input"
            required
            disabled={props.disabled}
            value={value}
            onBlur={onBlur || props.handleBlur || (() => {})}
            onChange={props.onChange || field.onChange}
            data-test-id={props.dataTestId}
            autoComplete={props.autoComplete || "off"}
            maxLength={maxLength || props.maxLength || undefined}
          />
          <label
            style={{ margin: "0px" }}
            id={`label-for-${props.id}`}
            htmlFor={props.id}
            className="c-form-field__label ccpa_form_label"
          >
            {props.placeHolder}
          </label>
        </div>
      </div>
      {props.error && (
        <p style={{ margin: "0px" }} className="c-error-message ccpa_form_error">
          {props.helpContent}
        </p>
      )}
    </div>
  );
};

export const CustomInputDateComponent = ({
  field,
  ...props
}) => {
  const [shouldGoToNext, setShouldGoToNext] = useState({
    "day": false,
    "month": false,
    "year": false,
  });

  let initialMonth;
  let initialDay ;
  let initialYear;
  if (props.secureKeyDoB) {
    field.value = props.disabled;
  }

  // If the value comes from secureKey
  if (field.value?.includes("-")) {
    initialMonth = field.value?.split('-')[1] || "";
    initialDay = field.value?.split('-')[2] || "";
    initialYear = field.value?.split('-')[0] || "";
  } else {
    initialMonth = field.value?.split('/')[0] || "";
    initialDay = field.value?.split('/')[1] || "";
    initialYear = field.value?.split('/')[2] || "";
  }

  

  const [year, setYear] = useState(initialYear);
  const [month, setMonth] = useState(initialMonth);
  const [day, setDay] = useState(initialDay);

  const handleOnChangeMonth = (e) => {
    const { value } = e.target;
    const valueNumber = parseInt(value);

    if (valueNumber > 12) return;
    let newMonth;
    if (valueNumber > 1 && value.length === 1) {
      newMonth = `0${value}`;
      document.getElementById("day-input").focus();
    } else {
      newMonth = value;
    }

    if (newMonth === '00') return;

    setMonth(newMonth);
  };

  useEffect(() => {
    if (month.length === 2) document.getElementById("day-input").focus();
  }, [month]);

  const handleOnChangeDay = (e) => {
    const { value } = e.target;
    const valueNumber = parseInt(value);

    if (valueNumber > 31) return;
    let newDay;
    if (valueNumber > 3 && value.length === 1) {
      newDay = `0${value}`;
      document.getElementById("year-input").focus();
    } else {
      newDay = value;
    }

    if (newDay === '00') return;

    setDay(newDay);

    if (!value) e.preventDefault();
  };

  useEffect(() => {
    let caretPos = 2;
    try {
      caretPos = document.getElementById("day-input").selectionStart;
    } catch (error) {}

    if (day.length === 2 && caretPos === 2) {
      document.getElementById("year-input").focus();
    }
  }, [day]);

  const onChangeYear = (e) => {
    const { value } = e.target;

    if (value === '0') return;

    setYear(value);
  }

  const handleOnBlur = () => {
    if (!day && !month && !year) {
      let elements = document.getElementsByClassName('date-slash');
      for (let i = 0; i < elements.length; i++) {
        let child = elements[i];
        child.style.display = 'none';
      }
    }
  }

  const setDate = () => {
    props.setFieldValue(props.id, `${month}/${day}/${year}`);
  };

  useEffect(setDate, [month, day, year]);

  const handleOnFocus = (e) => {
    let elements = document.getElementsByClassName('date-slash');
    for (let i = 0; i < elements.length; i++) {
      let child = elements[i];
      child.style.display = 'initial';
    }

    e.target.select();
  }

  const handleSpecialKeysDate = (e, field) => {
    const caretPos = document.getElementById(`${field}-input`).selectionStart;
    let shouldGoTemp = shouldGoToNext;
    if (e.key === "Backspace" || e.key === "Delete") {
      if (field === "day") {
        if (day === "") {
          document.getElementById("month-input").focus();
        } else if (day === '0') {
          document.getElementById("day-input").focus();
        }
      } else if (field === "year") {
        if (year === "") document.getElementById("day-input").focus();
      }
    } else if (e.key === "ArrowLeft") {
      if (field === "day" && caretPos === 0) {
        if (shouldGoToNext[field]) {
          document.getElementById("month-input").focus();
          shouldGoTemp = shouldGoToNext;
          shouldGoTemp[field] = false;
          setShouldGoToNext(shouldGoTemp);
        } else {
          shouldGoTemp = shouldGoToNext;
          shouldGoTemp[field] = true;
          setShouldGoToNext(shouldGoTemp);
        }
      } else if (field === "year" && caretPos === 0) {
        if (shouldGoToNext[field]) {
          document.getElementById("day-input").focus();
          shouldGoTemp = shouldGoToNext;
          shouldGoTemp[field] = false;
          setShouldGoToNext(shouldGoTemp);
        } else {
          shouldGoTemp = shouldGoToNext;
          shouldGoTemp[field] = true;
          setShouldGoToNext(shouldGoTemp);
        }
      } else {
        shouldGoTemp[field] = false;
        setShouldGoToNext(shouldGoTemp);
      }
    } else if (e.key === "ArrowRight") {
      if (field === "month" && caretPos === 2) {
        if (shouldGoToNext[field]) {
          document.getElementById("day-input").focus();
          shouldGoTemp = shouldGoToNext;
          shouldGoTemp[field] = false;
          setShouldGoToNext(shouldGoTemp);
        } else {
          shouldGoTemp = shouldGoToNext;
          shouldGoTemp[field] = true;
          setShouldGoToNext(shouldGoTemp);
        }
      } else if (field === "day" && caretPos === 2) {
        if (shouldGoToNext[field]) {
          document.getElementById("year-input").focus();
          shouldGoTemp = shouldGoToNext;
          shouldGoTemp[field] = false;
          setShouldGoToNext(shouldGoTemp);
        } else {
          shouldGoTemp = shouldGoToNext;
          shouldGoTemp[field] = true;
          setShouldGoToNext(shouldGoTemp);
        }
      } else {
        shouldGoTemp[field] = false;
        setShouldGoToNext(shouldGoTemp);
      }
    }
  };

  const handleOnKeyPress = (e) => {
    const key = e.key;
    if (!key.match(/^\d*$/i)) return e.preventDefault();
  };  

  return (
    <div
      className={`c-form-field ccpa_c-form-field ${props.helpContent && "ccpa-error"} ${props.disabled && "is-disabled"}`}
    >
      <div className={`c-form-field__box ccpa_form_input ${props.className}`}>
        <div
          data-test-id={props.dataTestId}
          id="date-field-wrapper"
          className="c-input"
        >
          {/* MONTH */}
          <input
            type="text"
            id="month-input"
            aria-label="month-input"
            data-testid="test-month-date"
            className="c-input__input c-input__input__date"
            data-tr-component="Input Field"
            data-tr-function="Text Input"
            required
            disabled={props.disabled}
            maxLength={2}
            onChange={handleOnChangeMonth}
            value={month}
            onKeyUp={(e) => {
              handleSpecialKeysDate(e, "month");
            }}
            onKeyPress={handleOnKeyPress}
            onBlur={handleOnBlur}
            onFocus={handleOnFocus}
            autoComplete={props.autoComplete ? props.autoComplete : "off"}
          />
          <label className="date-slash">/</label>
          {/* DAY */}
          <input
            type="text"
            id="day-input"
            aria-label="day-input"
            data-testid="test-day-date"
            className="c-input__input c-input__input__date"
            data-tr-component="Input Field"
            data-tr-function="Text Input"
            required
            disabled={props.disabled}
            maxLength={2}
            onChange={handleOnChangeDay}
            value={day}
            onKeyUp={(e) => {
              handleSpecialKeysDate(e, "day");
            }}
            onKeyPress={handleOnKeyPress}
            onBlur={handleOnBlur}
            onFocus={handleOnFocus}
            autoComplete={props.autoComplete ? props.autoComplete : "off"}
          />
          <label className="date-slash">/</label>
          {/* YEAR */}
          <input
            type="text"
            id="year-input"
            aria-label="year-input"
            data-testid="test-year-date"
            className="c-input__input c-input__input__date"
            data-tr-component="Input Field"
            data-tr-function="Text Input"
            required
            disabled={props.disabled}
            maxLength={4}
            onChange={onChangeYear}
            value={year}
            onKeyUp={(e) => {
              handleSpecialKeysDate(e, "year");
            }}
            onKeyPress={handleOnKeyPress}
            onBlur={handleOnBlur}
            onFocus={handleOnFocus}
            autoComplete={props.autoComplete ? props.autoComplete : "off"}
          />
          <label
            id="date-label"
            htmlFor="month-input"
            className="c-form-field__label ccpa_form_label"
          >
            {props.placeHolder} {props.value}
          </label>
        </div>
      </div>
      {props.error && (
        <p
          style={{ margin: "0px" }}
          className="c-error-message ccpa_form_error"
        >
          {props.helpContent}
        </p>
      )}
    </div>
  );
};

export const customInputSelectComponent = ({
  field,
  ...props
}) => {
  return (
    <div className="c-form-field ccpa_c-form-field">
      <div className="c-form-field__box ccpa_form_input">
        <div id="select-state-dropdown" className="c-input">
          <select
            onChange={field.onChange}
            value={field.value}
            id={props.id}
            className="custom-select-bronson c-input__input"
            required
          >
            <option
              aria-selected={field.value === ""}
              className="custom-select-option"
              id="select-state"
              value=""
            />
            {(props?.options).map((option) => (
              <option
                aria-selected={field.value === option.abbreviation}
                className="custom-select-option"
                key={option.abbreviation}
                value={option.abbreviation}
              >
                {option.name}
              </option>
            ))}
          </select>
          <label
            htmlFor={props.id}
            className="c-form-field__label ccpa_form_label"
          >
            {props.placeHolder}
          </label>
        </div>
      </div>
      {props.error && (
        <p
          style={{ margin: "0px" }}
          className="c-error-message ccpa_form_error"
        >
          {props.helpContent}
        </p>
      )}
    </div>
  );
};

// Add proptypes for CustomInputComponentBlur
CustomInputComponentBlur.propTypes = {
  field: PropTypes.object.isRequired,
  onBlur: PropTypes.func,
  maxLength: PropTypes.number,
  id: PropTypes.string,
  placeHolder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.bool,
  helpContent: PropTypes.string,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
  autoComplete: PropTypes.string,
  maskValue: PropTypes.func,
  handleBlur: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

confirmationNumberComponent.propTypes = CustomInputComponentBlur.propTypes;
customInputComponent.propTypes = CustomInputComponentBlur.propTypes;

CustomInputDateComponent.propTypes = {
  field: PropTypes.object.isRequired,
  id: PropTypes.string,
  placeHolder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.bool,
  helpContent: PropTypes.string,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
  autoComplete: PropTypes.string,
  secureKeyDoB: PropTypes.bool,
  setFieldValue: PropTypes.func,
  className: PropTypes.string,
};

export default customInputComponent;
